import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const AdminAnnouncements = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload();
    const [tagName, setTagName] = useState('')
    const [tagDescription, setTagDescription] = useState('')
    const [tagLastDate, setTagLastDate] = useState('')
    const today = new Date().toISOString().split('T')[0]

    const [courses, setCourses] = useState([])
    const [editId, setEditId] = useState(null)
    const [error, setError] = useState('')
    const [errord, setErrord] = useState('')
    const [errorL, setErrorL] = useState('')
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const apiUrl = `/get-announcement`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setCourses(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, []);

    useEffect(() => {
        if (tagName !== '') {
            setError('')
        }
        if (tagDescription !== '') {
            setErrord('')
        }
        if (tagLastDate !== '') {
            setErrorL('')
        }
    }, [tagName, tagDescription, tagLastDate])


    const addCourse = () => {
        const apiUrl = `/add-announcement`;
        if (tagName !== '' && tagDescription !== '' && tagLastDate !== '') {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, {
                title: tagName,
                content: tagDescription,
                expiryDate: tagLastDate
            })
                .then(response => {
                    setCourses((prevCourses) => [...prevCourses, response.data.result]);
                    setTagName('')
                    setTagDescription('')
                    setTagLastDate('')
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            if (tagName == '') {
                setError("This field is required.")
            }
            if (tagDescription == '') {
                setErrord("This field is required.")
            }
            if (tagLastDate == '') {
                setErrorL("This field is required.")
            }
        }
    }

    const deleteCourse = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-announcement?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    setCourses((prevCourses) => [...prevCourses].filter((course) => course.id != id));
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateCourse = () => {
        setLoading(true);
        const apiUrl = `/edit-announcement?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, {
            title: tagName,
            content: tagDescription,
            expiryDate: tagLastDate
        })
            .then(response => {
                setCourses((prevCourses) => [...prevCourses].map((course) => course.id == editId ? response.data.result : course));
                setEditId(null);
                setTagName('')
                setTagDescription('')
                setTagLastDate('')
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleChange = (editor) => {
        const value = editor.getData();
        setTagDescription(value);
    };

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    setLoading(true);
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err?.response?.data?.error);
                            })
                            .finally(() => {
                                setLoading(false); // End loading
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span> Admin Announcements</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-bullhorn"></i> Admin Announcements</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-12 board_name mt-3 mb-3">
                                                    <label for="title" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Title</label>
                                                    <input type="text" className="form-control" id="title" name='title' value={tagName} onChange={(e) => setTagName(e.target.value)} />
                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>

                                                <div className="col-md-12 board_name  mt-3 mb-3">
                                                    <label for="content" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Announcements</label>
                                                    {/* <input type="text" className="form-control" id="content" name='content' value={tagDescription} onChange={(e) => setTagDescription(e.target.value)} /> */}
                                                    <div
                                                        style={{
                                                            width: 'calc(100% - 290px)',
                                                            // padding: '0.375rem 0.75rem',
                                                            paddingLeft: 0,
                                                        }}
                                                    >
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={tagDescription}
                                                            onChange={(event, editor) => handleChange(editor)}
                                                            config={{ extraPlugins: [uploadPlugin] }}
                                                            onInit={(editor) => uploadPlugin(editor)}
                                                        />
                                                    </div>
                                                    {errord && <p style={{ color: 'red' }}>{errord}</p>}
                                                </div>

                                                <div className="col-md-6 board_name  mt-3 mb-3">
                                                    <label for="expiryDate" className="col-form-label"><span style={{ color: "red" }}>*</span>Expiry Date </label>
                                                    <input type="date" className="form-control" id="expiryDate" name='expiryDate' value={tagLastDate} onChange={(e) => setTagLastDate(e.target.value)} min={today} />
                                                    {errorL && <p style={{ color: 'red' }}>{errorL}</p>}
                                                </div>

                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto new_button">
                                                        {!editId && <button className="btn btn-primary" style={{ marginRight: '20px' }} type="button" onClick={addCourse}>Save</button>
                                                        }                                                        <button className="btn btn-danger delete_icon delete_icon" type="button" style={{ marginRight: "20px" }} onClick={() => { setTagName(''); setTagDescription(''); setTagLastDate(''); setEditId('') }}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateCourse} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">Title</th>
                                                                        <th scope="col">Announcements</th>
                                                                        <th scope="col">Date</th>
                                                                        <th scope="col">Expiry Date</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        courses.length > 0 ?
                                                                            courses.map((course, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row">{index + 1}</th>
                                                                                        <td>{course.title}</td>
                                                                                        {/* <td>{course.content}</td> */}
                                                                                        <td
                                                                                            style={{
                                                                                                verticalAlign: 'middle', // center vertically
                                                                                                textAlign: 'left',       // align text to the left
                                                                                                padding: '8px',          // optional, for spacing
                                                                                                fontSize: 'inherit',
                                                                                                lineHeight: 'normal',
                                                                                                // color: 'inherit'
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: course.content
                                                                                                        .replace(/<\/?p[^>]*>/g, '') // optional: remove <p> tags
                                                                                                        .replace(/style="[^"]*"/g, '') // optional: remove inline styles
                                                                                                }}
                                                                                                style={{
                                                                                                    display: 'inline',    // ensure it stays inline
                                                                                                    margin: 0,
                                                                                                    padding: 0
                                                                                                }}
                                                                                            />
                                                                                        </td>

                                                                                        {/* </td> */}
                                                                                        {/* <td>{moment(course.createdAt).format('DD-MM-YYYY')}</td> */}
                                                                                        <td>{course.createdAt.split(',')[0]}</td>
                                                                                        <td>{moment(course?.expiryDate).format('DD-MM-YYYY')}</td>

                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setTagName(course.title);
                                                                                                setTagDescription(course.content);
                                                                                                setTagLastDate(moment(course?.expiryDate).format('YYYY-MM-DD'));
                                                                                                setEditId(course.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === course.id} onClick={() => deleteCourse(course.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center', padding: '50px' }}>No  Admin Announcements Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AdminAnnouncements;